module.exports = __webpack_public_path__ + "static/media/pouce.526818e6.svg";